import axios from 'axios';
const SERVER = process.env.REACT_APP_API_URL
const GATEWAY = process.env.REACT_APP_IPFS_GATEWAY

export const getSharableCollectionData = async ({ userId, publicId }) => {

  try {
    const options = {
      method: 'GET',
      url: `${SERVER}/users/share/nft/${userId}/${publicId}`,
      headers: {
        Accept: 'application/json',
      }

    }
    const result = await axios(options)
    const response = result.data // await data.json()
    return response
  } catch (e) {
    console.warn('Error in user/getSharableCollectionData()', e.message)
    throw e
  }
}



export const getSharableTokens = async ({ publicId }) => {

  try {
    const options = {
      method: 'GET',
      url: `${SERVER}/users/share/nft/tokens/${publicId}`,
      headers: {
        Accept: 'application/json',
      }

    }
    const result = await axios(options)
    const response = result.data // await data.json()
    return response
  } catch (e) {
    console.warn('Error in user/getSharableCollectionData()', e.message)
    throw e
  }
}

export const getTokenData = async (tokenIds) => {
  // try auth
  try {
    const options = {
      method: 'POST',
      url: `${SERVER}/token/data`,
      headers: {
        Accept: 'application/json'
      },
      data: {
        tokenIds
      }
    }
    const result = await axios(options)
    const response = result.data

    return response.result
  } catch (e) {
    console.warn('Error in user/getTokenData()', e.message)
    throw e
  }
}

export const getDataFromIpfsGateway = async (url) => {
  try {
    const options = {
      method: 'GET',
      url: `${GATEWAY}/ipfs/view/${url}`,
      headers: {
        Accept: 'application/json'
      }
    }
    const result = await axios(options)
    const response = result.data
    return response
  } catch (e) {
    console.warn('Error in user/getTokenDataFromGateway()', e.message)
    return null
  }
}
